import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 10h2a2 2 0 0 1 2 2v5h-3a2 2 0 1 1 0 -4h3","key":"svg-0"}],["path",{"d":"M16 7v10","key":"svg-1"}],["path",{"d":"M18 11l-4 2","key":"svg-2"}],["path",{"d":"M10.5 17a1.5 1.5 0 0 0 0 3","key":"svg-3"}]]

const IconAlphabetPolish = createReactComponent('outline', 'alphabet-polish', 'AlphabetPolish', __iconNode);

export default IconAlphabetPolish;